export default __webpack_public_path__ + "static/media/setimg.92ec1f65.png";